import { MonacoEditor } from '@components/monaco/monacoEditor.code';
import useAction from '@hooks/useAction';
import useProcess from '@hooks/useProcess';
import useStore from '@hooks/useStore';
import type { OnChange } from '@monaco-editor/react';
import { CircularProgress } from '@mui/joy';
import { motion } from 'framer-motion';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import { LoaderBox } from '@/components/ui/loader';

export const CustomCodePage = observer(() => {
  const { codeStore } = useStore();
  const action = useAction();
  const process = useProcess();

  if (!process || process.isSmallProcess) {
    return (
      <LoaderBox>
        <CircularProgress />
      </LoaderBox>
    );
  }

  const codeModel = action?.codeModel;
  if (codeStore.lastCodeModel?.id !== codeModel?.id) {
    codeStore.lastCodeModel = codeModel;
  }

  codeStore.lastCodeModel = codeModel;

  if (!codeModel) {
    return <></>;
  }

  const onCodeChange: OnChange = value => {
    if (!value) {
      return;
    }
    codeModel.code = value;
  };

  return (
    <motion.div
      animate={{ opacity: 1 }}
      className="z-40 h-full w-full bg-[#fafafa]"
      initial={{ opacity: 0 }}
    >
      <MonacoEditor
        code={toJS(codeModel.code)}
        handleMonacoErrors={monacoErrors => codeModel.setErrors(monacoErrors)}
        modelId={action.traceKey.value}
        onCodeChange={onCodeChange}
        preCode={toJS(codeModel.getPreCode())}
      />
    </motion.div>
  );
});
